module.exports = __webpack_public_path__ + "img/productsDB_access.87ef862a.png";